import {useState,useEffect} from "react"
import tickIcon from "../assets/tick-2.svg"

export default function Checkbox({defaultValue,onChange,label}){

    const [checked,setChecked]=useState(defaultValue || false)

    useEffect(()=>{
        if(defaultValue !== undefined){
            setChecked(defaultValue)
        }
    },[defaultValue])

    const handleClick=()=>{
        const newValue = !checked
        setChecked(newValue)
        if(onChange){
            onChange(newValue)
        }
    }

    return(
        <div 
            className="checkbox-container noselect" 
            onClick={handleClick}
            style={{
                display:"flex",
                alignItems:"center",
                gap:"12px",
                cursor:"pointer"
            }}
        >
            <div 
                className={"checkbox-box"+(checked?" checkbox-box-checked":"")}
                style={{
                    width:"24px",
                    height:"24px",
                    borderRadius:"6px",
                    border: checked ? "2px solid #624DE3" : "2px solid #D8D2F8",
                    backgroundColor: checked ? "#624DE3" : "#FFFFFF",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    transition:"all 0.2s ease"
                }}
            >
                {checked && 
                    <img 
                        src={tickIcon} 
                        alt="checked" 
                        style={{width:"14px",height:"14px"}}
                    />
                }
            </div>
            {label && 
                <div 
                    className="checkbox-label"
                    style={{
                        color:"#624DE3",
                        fontSize:"15px",
                        fontWeight:"500"
                    }}
                >
                    {label}
                </div>
            }
        </div>
    )
    
}
